

module.exports = __webpack_require__.stylable.create(
    "buttonnext934096820",
    {"classes":{"root":"buttonnext934096820__root","content":"buttonnext934096820__content","prefix":"buttonnext934096820__prefix","suffix":"buttonnext934096820__suffix"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    /*! ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.st.css */ 446,
    null
);
